import React, { useRef } from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import SettingsContainer from "../pages/Settings/Settings.container";
import MainContainer from "../pages/Main/Main.container";
import EdgeContainer from "../pages/Edge/Edge.container";
import GatewaysContainer from "../pages/Gateways/Gateways.container";
import FleetContainer from "../pages/Fleet/Fleet.container";

import DashboardLayout from "../layout/DashboardLayout";
import { MapRefProvider } from "../context/MapRefContext";
import { useDashboardData } from "../hooks/useDashboardData";
import { DASHBOARD_PATHS } from "../constants/paths";

export default function Dashboard() {
  const mapRef = useRef(null);
  const currentUser = useSelector((state) => state.user.currentUser);

  useDashboardData();

  if (!currentUser) {
    return <div>Loading user data...</div>;
  }

  return (
    <MapRefProvider value={mapRef}>
      <DashboardLayout>
        <Routes>
          <Route path={"/dashboard" + DASHBOARD_PATHS.HOME} element={<MainContainer />} />
          <Route path={"/dashboard" + DASHBOARD_PATHS.FLEET} element={<FleetContainer />} />
          <Route path={"/dashboard" + DASHBOARD_PATHS.EDGE_DEVICES} element={<EdgeContainer />} />
          <Route path={"/dashboard" + DASHBOARD_PATHS.IOT_GATEWAYS} element={<GatewaysContainer />} />
          <Route path={"/dashboard" + DASHBOARD_PATHS.SETTINGS} element={<SettingsContainer />} />
          <Route path="*" element={<Navigate to={DASHBOARD_PATHS.HOME} replace />} />
        </Routes>
      </DashboardLayout>
    </MapRefProvider>
  );
} 